var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitRepo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 35.65V24.8",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5375 46.5C23.3197 46.5 25.5751 44.2446 25.5751 41.4625C25.5751 38.6803 23.3197 36.425 20.5375 36.425C17.7554 36.425 15.5 38.6803 15.5 41.4625C15.5 44.2446 17.7554 46.5 20.5375 46.5Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 24.8C22.7181 24.8 24.7999 22.7181 24.7999 20.15C24.7999 17.5818 22.7181 15.5 20.15 15.5C17.5818 15.5 15.5 17.5818 15.5 20.15C15.5 22.7181 17.5818 24.8 20.15 24.8Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.85 24.8C44.4182 24.8 46.5 22.7181 46.5 20.15C46.5 17.5818 44.4182 15.5 41.85 15.5C39.2819 15.5 37.2001 17.5818 37.2001 20.15C37.2001 22.7181 39.2819 24.8 41.85 24.8Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3567 35.6499C21.0542 32.9374 23.5342 30.9225 26.4533 30.9483L31.775 30.9741C35.8308 30.9999 39.2925 28.3907 40.5584 24.7482",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.16661H38.75C51.6667 5.16661 56.8333 10.3333 56.8333 23.2499V38.7499C56.8333 51.6666 51.6667 56.8333 38.75 56.8333H23.25C10.3333 56.8333 5.16666 51.6666 5.16666 38.7499V23.2499C5.16666 10.3333 10.3333 5.16661 23.25 5.16661Z",
    stroke: "#F5F5F5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitRepo);
export default __webpack_public_path__ + "static/media/git-repo.8244aa25c9eefc83345c26ea0df137e8.svg";
export { ForwardRef as ReactComponent };